import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'
import OCRScopingJobBulkActionViewModel from '../../SidePanel/OCRScopingJobBulkActionViewModel'

/**
 * Modal to confirm the bulk review of scoping jobs.
 */
export default class OCRConfirmBulkReviewModalViewModel extends ModalViewModel {
  constructor(
    public readonly ocrScopingJobBulkActionViewModel: OCRScopingJobBulkActionViewModel,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  confirm = async () => {
    this.close()
    await this.ocrScopingJobBulkActionViewModel.bulkReview()
  }
}
